import { Suspense } from 'react';
import { RouterProvider } from 'react-router-dom';
import LoadingSpinner from '@/components/feedback/LoadingSpinner';
import { router } from '@/app/router/index';

export default function App() {
  return (
    <Suspense fallback={<LoadingSpinner />}>
      <RouterProvider router={router} />
    </Suspense>
  );
}
